// dopa-utm-tracker.js
(function() {
  const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ref'];
  
  function getQueryParams() {
    const params = new URLSearchParams(window.location.search);
    let utmData = {};
    let hasUTM = false;
    
    PARAMS.forEach(key => {
      const val = params.get(key);
      if (val) {
        utmData[key] = val;
        hasUTM = true;
      }
    });
    
    return hasUTM ? utmData : null;
  }

  function initTracker() {
    const currentUTM = getQueryParams();
    if (currentUTM) {
      localStorage.setItem('dopa_utm_data', JSON.stringify(currentUTM));
    }
  }

  window.dopaGetAttribution = function() {
    try {
      const stored = localStorage.getItem('dopa_utm_data');
      return stored ? JSON.parse(stored) : null;
    } catch(e) {
      return null;
    }
  };

  initTracker();
})();
